import React, { useContext } from "react";
import { SDLCMetadata } from "@sscs/types";
import { DataTable, Page, hasActiveFilters } from "@sscs/ui";
import { formatCount } from "@sscs/utils";
import { issuesID } from "../../constants";
import { initFilter, paginationUpdated, resetFilter, selectFilter, selectPagination, selectSort, sortUpdated, } from "../../store/issuesSlice";
import { selectScrollTo } from "../../store/sdlcReportSlice";
import { ExportButton } from "../common";
import { ReportContext } from "../context";
import { useReportDispatch, useReportSelector, useScrollIntoView, } from "../hooks";
import { useGetIssuesQuery } from "../services/issues.api";
import { useGetReportSummaryQuery } from "../services/shared.api";
import { getQueryStatus } from "../utils";
import Filter from "./Filter";
import Issue from "./issue/Issue";
import styles from "./issues.module.scss";
const COLUMNS = [
    { id: "info", label: "Info", width: "70px" },
    {
        id: "id",
        label: "ID",
        sortProperty: "id",
        sortId: "issues-sort-id",
        width: "110px",
    },
    { id: "description", label: "Description", width: "100%" },
    {
        id: "policy_category",
        label: "Issue category",
        sortProperty: "policy_category",
        sortId: "issues-sort-category",
        width: "200px",
    },
    { id: "enabled", label: "Enabled", width: "85px" },
    {
        id: "grade",
        label: "Priority",
        sortProperty: "grade",
        sortId: "issues-sort-priority",
        startReverse: true,
        width: "115px",
    },
    { id: "cicd", label: "CI/CD", width: "125px" },
    {
        id: "violations_count",
        label: "# Files",
        sortProperty: "violations_count",
        sortId: "issues-sort-count",
        startReverse: true,
        width: "110px",
    },
];
const Issues = () => {
    var _a;
    const { reportId, diffId, onReportExport, activeExport, roles, selectedCheck, } = useContext(ReportContext);
    const dispatch = useReportDispatch();
    const scrollTo = useReportSelector(selectScrollTo);
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const pagination = useReportSelector(selectPagination);
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    const { data = { issues: [], match_count: 0, risk_count: 0 }, isFetching, isLoading, isError, error, } = useGetIssuesQuery({
        reportId,
        diffId,
        pagination,
        filter,
        sort,
    });
    const totalIssueCount = (_a = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.checks_report.report.scans[selectedCheck]) === null || _a === void 0 ? void 0 : _a.statistics.quality.issues[SDLCMetadata.policy_metrics_t.issues_total_k];
    useScrollIntoView(scrollTo, issuesID);
    const handleSortChange = (sort) => {
        dispatch(sortUpdated(sort));
    };
    return (React.createElement(Page.Root, null,
        React.createElement(Page.Header, { title: "Issues", details: [formatCount(totalIssueCount !== null && totalIssueCount !== void 0 ? totalIssueCount : 0, "Issue")], actions: roles.canExportSarif ? (React.createElement(ExportButton, { id: "issues-policy-violations-export-as-sarif", text: "Export as Sarif", onClick: () => onReportExport === null || onReportExport === void 0 ? void 0 : onReportExport("sarif"), isDisabled: activeExport.sarif })) : undefined }),
        React.createElement(Page.Filters, { found: {
                id: "issues-clear-all-filters",
                label: `${data.match_count.toLocaleString()} issue${data.match_count === 1 ? "" : "s"} causing ${data.risk_count.toLocaleString()} risk${data.risk_count === 1 ? "" : "s"}`,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => dispatch(resetFilter()),
            } },
            React.createElement(Filter, null)),
        React.createElement(Page.Body, null,
            React.createElement(DataTable, { tableClassName: styles.table, columns: COLUMNS, sort: sort, onSortChange: handleSortChange, empty: {
                    subject: "issues",
                    filters: {
                        active: hasActiveFilters(initFilter, filter),
                        onReset: () => dispatch(resetFilter()),
                    },
                }, status: getQueryStatus({
                    isLoading,
                    isFetching,
                    isError,
                    error,
                    data,
                }), pagination: {
                    id: "issues-pagination",
                    itemCount: data.match_count,
                    pagination,
                    onChange: (pagination) => dispatch(paginationUpdated(pagination)),
                } }, data.issues.map((issue) => (React.createElement(Issue, { key: issue.id, issue: issue })))))));
};
export default Issues;
//# sourceMappingURL=Issues.js.map